const PRE = 'AUTH_';


export const SIGNIN = PRE + 'SIGNIN';
export const SIGNUP = PRE + 'SIGNUP';






// WEBPACK FOOTER //
// ./src/routes/public/Login/actionTypes.js